import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { HealthServicesLeftMenuList } from "../utils/constants";
import { RenderNavItem } from "../components/RenderNavItem";

const Health_services_Health_Home = () => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
          <div className="container">
            <div className="section-main-heading2">
              <h4 className="fontSizeClass"> </h4>
            </div>
          </div>
        </div>
      </section>
      {/* End Slider */}
      <section className="section inner-pad1">
        <div className="container ">
          <div className="row">
            <div className="col-lg-3">
            <div className="site-menu  min-height-400">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {HealthServicesLeftMenuList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title2">
                    <h3 className="fontSizeClass">{t("HEALTH DEPARTMENT")} </h3>
                  </div>
                  <div className="about-head1">
                    <div className="dig-login1 dig-login2">
                      <div className="log-form inner-log-form">
                        <h3 className="fontSizeClass">
                          {t("HEALTH ACTIVITIES")}
                        </h3>
                        <div className="row">
                          <div className="col-lg-12 col-md-12 form-group pt-2">
                            <div className="health-dept">
                              <img
                                src="assets/img/logo.png"
                                className="log_img mx-auto d-block"
                                alt="alt"
                              />
                              <h4 style={{ marginTop: "10px" }}>
                                {t(
                                  "To cater Health in all possible ways to the citizens of Kolkata, is envisaged as the prime objective of Health Department, through various preventive and curative measures. Functions and functionaries of Health Department, thus, may be categorized under the following heads"
                                )}
                                .
                              </h4>
                              {/* <p className="text-center d-block">
                                <DownloadFileByFileStoreId
                                  fileStoreId={
                                    "dc043ec5-2acf-4d60-be18-1c90eeb983ab"
                                  }
                                  label={
                                    "MONER ALO Mental Health Program of KMC"
                                  }
                                />
                              </p> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Health_services_Health_Home;
